import 'choerodon-ui/lib/style/index.less';
// style dependencies
import '../../trigger-field/style';
import '../../spin/style';
import 'choerodon-ui/lib/menu/style';
import './index.less';
